// extracted by mini-css-extract-plugin
export var headerXL = "BlogPost-module--headerXL--2Ts3P";
export var headerL = "BlogPost-module--headerL--2JHhK";
export var headerM = "BlogPost-module--headerM--3eq3p";
export var headerS = "BlogPost-module--headerS--1bUV0";
export var headerXS = "BlogPost-module--headerXS--PQw29";
export var blogHeaderXL = "BlogPost-module--blogHeaderXL--221b7";
export var blogHeaderL = "BlogPost-module--blogHeaderL--1yM1F";
export var blogHeaderM = "BlogPost-module--blogHeaderM--3BQIj";
export var blogHeaderS = "BlogPost-module--blogHeaderS--NEekw";
export var blogHeaderXS = "BlogPost-module--blogHeaderXS--8yI7N";
export var headerPreamble = "BlogPost-module--headerPreamble--3_oPI";
export var preHeader = "BlogPost-module--preHeader--7Akc6";
export var textNormal = "BlogPost-module--textNormal--3Gfbi";
export var textSmall = "BlogPost-module--textSmall--39QAQ";
export var textSmallAlternate = "BlogPost-module--textSmallAlternate--2OYFV";
export var legend = "BlogPost-module--legend--L2ljh";
export var caption = "BlogPost-module--caption--1CzII";
export var gradientBackground = "BlogPost-module--gradientBackground--1C1ST";
export var ellipsis = "BlogPost-module--ellipsis--2G7TN";
export var globalContainer = "BlogPost-module--globalContainer--BtgcX";
export var maxWidth = "BlogPost-module--maxWidth--20hep";
export var clipBottom = "BlogPost-module--clipBottom--3y8wN";
export var clipTopBottom = "BlogPost-module--clipTopBottom--1ZuzK";
export var container = "BlogPost-module--container--2g0Cp";
export var header = "BlogPost-module--header--1qQMc";
export var title = "BlogPost-module--title--35CCj";
export var divider = "BlogPost-module--divider--2-xmo";
export var blogPostColumn = "BlogPost-module--blogPostColumn--Ybg7S";
export var authorContainer = "BlogPost-module--authorContainer--19OKU";
export var avatar = "BlogPost-module--avatar--3pbnH";
export var authorName = "BlogPost-module--authorName--2r5rM";
export var authorTitle = "BlogPost-module--authorTitle--2gH72";
export var subtitle = "BlogPost-module--subtitle--3jMTp";
export var ch2 = "BlogPost-module--ch2--mvTN3";
export var ch2Container = "BlogPost-module--ch2-container--2SMZi";